import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SiteHeader />
      <main className="flex-1 pt-16 md:pt-20 flex items-center">
        <div className="w-full px-4 md:px-10 py-20 text-center">
          <p className="font-heading font-black text-6xl md:text-8xl text-primary-200 select-none">
            404
          </p>
          <h1 className="mt-4 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            这个页面可能已经合并或撤下了
          </h1>
          <p className="mt-3 text-sm text-foreground-500">
            当前访问的路径：<span className="text-foreground-700">{location.pathname}</span>
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-home-4-line" />
              回到首页
            </Link>
            <Link
              to="/rankings"
              className="inline-flex items-center gap-1.5 px-6 py-3 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-trophy-line" />
              看年度 TOP 榜
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}